import {
    HttpInterceptor,
    HttpRequest,
    HttpHandler,

} from '@angular/common/http';
import { Injectable } from '@angular/core';
// import { EncrDecrService } from './encr-decr.service';
export const InterceptorSkipHeader = 'X-Skip-Interceptor';

@Injectable()
export class HttpInterceptorService implements HttpInterceptor {
    req: HttpRequest<any>;
    constructor() { }
    intercept(request: HttpRequest<any>, next: HttpHandler) {

        let userdata = {};

        let token = '';

        if (localStorage.getItem('info') !== null) {
            userdata = JSON.parse(localStorage.getItem('info'));
            token= userdata['token'];
        }



        if (request.headers.has(InterceptorSkipHeader)) {

            const headers = request.headers.delete(InterceptorSkipHeader);
            this.req = request.clone({
                setHeaders: {
                    'Access-Control-Allow-Origin': '*',
                    Authorization: `Bearer ${token}`
                }
            });
            return next.handle(this.req);
        } else {
            if (localStorage.getItem('info') !== null) {
                this.req = request.clone({
                    setHeaders: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': '*',
                        Authorization: `Bearer ${token}`
                    }
                });
            } else {
                this.req = request.clone({
                    setHeaders: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': '*',
                    }
                });
            }
        }
        if (request.headers.get('noContentType')) {
            this.req = request.clone({
                setHeaders: { 
                    Authorization: `Bearer ${token}`
                 }
            });
        }
        return next.handle(this.req);
    }

}
